import { Button } from 'flowbite-react';
import React, { ReactNode } from 'react';

interface NotificationPopupModalProps {
  message: string;
  buttonText: string | ReactNode;
  close:()=>void,
  action:()=>void,
  type: string
}

const NotificationPopupModal = ({ message, buttonText, close, action }: NotificationPopupModalProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg">
      <p className="text-center text-sm text-gray-700 text-lg mb-4">{message}</p>
      <div className="flex gap-4">
        <Button onClick={()=>close()} className="bg-white text-black hover:text-white  border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-md">
          Close
        </Button>
        <Button onClick={()=>action()} className="bg-custom-button-green text-white px-4 py-2 rounded-md hover:bg-green-600 transition">
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default NotificationPopupModal;
